import Box from '@mui/material/Box'
import PageSelector from '../../components/PageSelector'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'
import { Typography } from '@mui/material'
import { useCallback } from 'react'
import { UserRoleNames } from '../../models/AccessControl'
import StartNewFileMinimizedComponent from '../../components/Architecture/StartNewFileMinimizedComponent'
import OrganizationSettingsComponent from '../../components/Architecture/OrganizationSettingsComponent'
import PageToolComponent from '../../components/PageToolComponent'
import { commonToolItems } from '../../configs/toolItemsConfig'
import TrialCountdown from '../../components/Payment/TrialCountdown'

interface LeftPanelProps {}

const LeftPanelComponent: React.FC<LeftPanelProps> = () => {
  const user = useSelector((state: RootState) => state.auth.user)

  const renderLeftPanel = useCallback(() => {
    switch (user?.role.name) {
      case UserRoleNames.Admin:
      case UserRoleNames.LeadingArchitect:
      case UserRoleNames.Architect:
        return renderArchitectPanel()
      case UserRoleNames.EngineeringAdmin:
      case UserRoleNames.LeadingStructuralEngineer:
      case UserRoleNames.LeadingElectricalEngineer:
      case UserRoleNames.StructuralEngineer:
      case UserRoleNames.ElectricalEngineer:
        return renderEngineerPanel()
      default:
        return renderArchitectPanel()
    }
  }, [user])

  const renderArchitectPanel = () => {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          height: '100%',
          width: '100%',
          boxSizing: 'border-box',
        }}
      >
        <Box
          gap='0.75rem'
          sx={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <OrganizationSettingsComponent />
          <StartNewFileMinimizedComponent />
          {!!user && (
            <Box
              gap='1rem'
              sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}
            >
              <Typography
                sx={{
                  color: '#797979',
                  fontSize: '0.67rem',
                  fontWeight: 500,
                  lineHeight: 'normal',
                  pl: '1rem',
                }}
              >
                Organization
              </Typography>
              <PageSelector role={user.role} />
            </Box>
          )}
        </Box>
        <Box>
          <TrialCountdown />
        </Box>
        <Box>
          <PageToolComponent
            tool={commonToolItems.find((tool) => tool.label === 'Settings')}
          />
        </Box>
      </Box>
    )
  }

  const renderEngineerPanel = () => {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          height: '100%',
          width: '100%',
          boxSizing: 'border-box',
        }}
      >
        <Box
          gap='0.75rem'
          sx={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {!!user && (
            <Box
              gap='0.5rem'
              sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}
            >
              <Typography
                sx={{
                  color: '#797979',
                  fontSize: '0.67rem',
                  fontWeight: 500,
                  lineHeight: 'normal',
                  pl: '1rem',
                }}
              >
                Organization
              </Typography>
              <PageSelector role={user.role} />
            </Box>
          )}
        </Box>
        <Box>
          <PageToolComponent
            tool={commonToolItems.find((tool) => tool.label === 'Settings')}
          />
        </Box>
      </Box>
    )
  }

  return <>{renderLeftPanel()}</>
}

export default LeftPanelComponent
